import React from 'react';
import { styled } from '@material-ui/core/styles';
import Chip, { ChipProps } from '@material-ui/core/Chip';
import { theme } from '../../styles/theme';
import { CustomChipProps } from './types';
import { alpha } from '@material-ui/core/styles/colorManipulator';

const CustomBoxShadow1 = `
0 1px 4px 0 rgba(69, 69, 69, 0.2),
0 1px 2px 0 rgba(69, 69, 69, 0.1)
`;

const CustomChip = styled(
  ({
    color,
    active,
    ...other
  }: CustomChipProps & Omit<ChipProps, keyof CustomChipProps>) => (
    <Chip {...other} />
  )
)({
  backgroundColor: (props: CustomChipProps) =>
    props.active
      ? 'white'
      : alpha(props.color || theme.color.primary.default, 0.3),
  '&:hover, &:focus': {
    backgroundColor: (props: CustomChipProps) =>
      props.active
        ? 'white'
        : alpha(props.color || theme.color.primary.default, 0.3),
  },
  '&:active': {
    boxShadow: (props: CustomChipProps) =>
      props.active ? CustomBoxShadow1 : 'none',
  },
  color: (props: CustomChipProps) => props.color || theme.color.primary.default,
  boxShadow: (props: CustomChipProps) =>
    props.active ? CustomBoxShadow1 : 'none',
});

export default CustomChip;
